<ng-container *ngIf="displayError">
  <span class="ax-error clr-subtext" #ref><ng-content></ng-content></span>
  <span class="ax-error clr-subtext" *ngIf="ref.childNodes.length === 0">
    {{errorMessage}}
  </span>
</ng-container>

